import i18n from 'i18next';

import getInitiativeTypes from '../helpers/getInitiativeTypes';

export default () => {
  const description = i18n.t('initiative-description');

  return [
    {
      title: i18n.t('initiative'),
      schema: {
        name: {
          type: 'Text',
          label: i18n.t('initiative-name'),
          help: i18n.t('initiative-name-help'),
          maxLength: 50,
          placeholder: i18n.t('initiative-name-placeholder'),
          validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
        },
        initiative_type: {
          type: 'RadioCards',
          label: i18n.t('initiative-type'),
          help: i18n.t('initiative-type-help'),
          options: getInitiativeTypes(),
          validators: [{ type: 'isRequired' }],
        },
        description: {
          type: 'TextEditor',
          label: description,
          help: i18n.t('initiative-description-help'),
          placeholder: description,
          textEditorOptions: { hasToolbar: true, size: 'large' },
        },
      },
    },
    {
      title: i18n.t('audience'),
      schema: {
        audiences: {
          type: 'AudienceChips',
          label: i18n.t('audience-selection'),
          help: i18n.t('audience-selection-help'),
        },
      },
    },
    {
      title: i18n.t('additional-tracking'),
      schema: {
        social_tracking: {
          type: 'Boolean',
          label: i18n.t('social'),
          help: i18n.t('social-tracking-help'),
          labelText: i18n.t('social-tracking-true'),
        },
        ecommerce_tracking: {
          type: 'Boolean',
          label: i18n.t('ecommerce'),
          help: i18n.t('ecommerce-tracking-help'),
          labelText: i18n.t('ecommerce-tracking-true'),
        },
        live_tracking: {
          type: 'Boolean',
          label: i18n.t('instructor-led'),
          help: i18n.t('instructor-led-tracking-help'),
          labelText: i18n.t('instructor-led-tracking-true'),
        },
      },
    },
  ];
};
